import refDataApi from '@/api/server/refData'

const refDataModule = {
  state: {
    genders: null
  },
  getters: {
    genders: (state) => state.genders
  },
  mutations: {
    setGenders(state, genders) {
      state.genders = genders
    }
  },
  actions: {
    async fetchReferenceData({ commit }) {
      const response = await refDataApi.fetchReferenceData()
      const refData = response.data

      // Extract genders from reference data - API returns array of datasets
      if (refData && Array.isArray(refData)) {
        let genders = refData.find((item) => item.name === 'Gender')?.data
        if (genders) {
          // Remap from retrieved API key/vals to useable key/vals
          genders = genders.map((child) => ({
            text: child.value,
            value: child.code
          }))
          commit('setGenders', genders)
        }
      }
    }
  }
}

export default refDataModule
